import { connect } from 'react-redux';

import appSelectors from 'selectors/app';
import PaymentRequestMessageItem from 'presentation/selfService/PaymentRequestMessageItem';
import uiEnums from 'enums/ui';
import uiEvents from 'events/ui';

export const mapStateToProps = state => {
  return {
    secureOrgId: appSelectors.getSecureOrgId(state),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onInitiateSecurePayment: () => {
      dispatch(uiEvents.navigateForward(uiEnums.LOCATIONS.SECURE_PAYMENT));
    },
  };
};

const PaymentRequestMessageItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentRequestMessageItem);

export default PaymentRequestMessageItemContainer;
